import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../common/theme/ISpcTheme';

export type MarketingCategoryTabsClasses =
  | 'marketingCategoryContainer'
  | 'selectedTab'
  | 'tab'
  | 'label'
  | 'trimTab'
  | 'selectedTrimTab'
  | 'indicator'
  | 'container'
  | 'wrapper';

const marketingCategoriesTabStyles = makeStyles<ISpcTheme, { hasBottomBorder: boolean }, MarketingCategoryTabsClasses>(
  theme => ({
    marketingCategoryContainer: {
      margin: '0 auto',
    },
    selectedTab: {
      fontWeight: theme.typography.fontWeightBold,
    },
    tab: {
      color: theme.palette.text.primary,
      minWidth: '100px',
    },
    label: {
      color: 'inherit',
      fontWeight: 'inherit',
    },
    trimTab: {
      textTransform: 'capitalize',
    },
    selectedTrimTab: {
      color: theme.palette.primary.main,
    },
    indicator: {
      height: 2,
      background: theme.palette.primary.main,
    },
    container: {
      borderBottom: ({ hasBottomBorder }) =>
        hasBottomBorder ? `1px solid ${theme.palette.primaryDisabled.main}` : 'none',
    },
    wrapper: {
      fontWeight: 'inherit',
    },
  }),
  { name: 'PVariants_MarketingCategoryTabs' },
);

export default marketingCategoriesTabStyles;
